<template>
  <div>
    <v-list-item
      ripple
      v-if="haveAccess(item) && (!item.menu || item.menu.length == 0)"
      :to="item.route"
    >
      <v-list-item-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title :class="item.menu ? 'subheading' : ''">{{
          resx.labels[item.name]
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-group
      :prepend-icon="item.icon"
      v-if="anyHaveAccess(item.menu) && item.menu && item.menu.length > 0"
      :value="active"
    >
      <v-list-item ripple slot="activator">
        <v-list-item-content>
          <v-list-item-title class="subheading">{{
            resx.labels[item.name]
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <app-menu-item
        v-for="subItem in item.menu"
        :key="subItem.name"
        :item="subItem"
      >
      </app-menu-item>
    </v-list-group>
  </div>
</template>

<script>
"use strict";

import authService from "@/services/AuthService";

export default {
  name: "app-menu-item",
  computed: {
    active() {
      return this.checkActive(this.item.menu);
    }
  },
  data() {
    return {};
  },
  methods: {
    checkActive(items) {
      if (!items) {
        return false;
      }
      let self = this;
      return items.some(item => {
        let isActive = false;
        if (item.menu) {
          isActive = this.checkActive(item.menu);
        } else {
          //isActive = item.route && item.route.name == self.$route.name;
          const itemRouteResolved = this.$router.resolve(
            item.route,
            null,
            false
          );
          const index = self.$route.path.indexOf(itemRouteResolved.route.path);
          isActive = item.route && index == 0;
        }
        return isActive;
      });
    },
    haveAccess(item) {
      return authService.haveAccess(item, this.$router);
    },
    anyHaveAccess(items) {
      return authService.anyHaveAccess(items, this.$router);
    }
  },
  props: ["item"]
};
</script>

<style lang="scss">
.v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 0px;
  position: absolute;
  right: 15px;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 4px;
}

.v-list-group__items .v-list-item {
  padding-left: 27px;
}

.v-list-group__items .v-list-item .v-list-item__content {
    padding-left: 5px;
}

</style>
